__turbopack_context__.v({
  "card": "CCompanyDigitalization-module__hqRs3q__card",
  "cardBody": "CCompanyDigitalization-module__hqRs3q__cardBody",
  "cardCta": "CCompanyDigitalization-module__hqRs3q__cardCta",
  "cardDesc": "CCompanyDigitalization-module__hqRs3q__cardDesc",
  "cardIconWrap": "CCompanyDigitalization-module__hqRs3q__cardIconWrap",
  "cardLink": "CCompanyDigitalization-module__hqRs3q__cardLink",
  "cardTitle": "CCompanyDigitalization-module__hqRs3q__cardTitle",
  "cards": "CCompanyDigitalization-module__hqRs3q__cards",
  "empty": "CCompanyDigitalization-module__hqRs3q__empty",
  "hero": "CCompanyDigitalization-module__hqRs3q__hero",
  "heroDescription": "CCompanyDigitalization-module__hqRs3q__heroDescription",
  "heroEyebrow": "CCompanyDigitalization-module__hqRs3q__heroEyebrow",
  "heroInner": "CCompanyDigitalization-module__hqRs3q__heroInner",
  "heroTitle": "CCompanyDigitalization-module__hqRs3q__heroTitle",
  "integrations": "CCompanyDigitalization-module__hqRs3q__integrations",
  "integrationsDescription": "CCompanyDigitalization-module__hqRs3q__integrationsDescription",
  "integrationsHeader": "CCompanyDigitalization-module__hqRs3q__integrationsHeader",
  "integrationsIcon": "CCompanyDigitalization-module__hqRs3q__integrationsIcon",
  "integrationsTitle": "CCompanyDigitalization-module__hqRs3q__integrationsTitle",
  "root": "CCompanyDigitalization-module__hqRs3q__root",
});
